var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,16.125,14.875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,0)",
    fillOpacity: 1,
    d: " M-11,1.125 C-11,1.125 10.75,1.125 10.75,1.125"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-11,1.125 C-11,1.125 10.75,1.125 10.75,1.125"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,16.125,14.875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,0,0)",
    fillOpacity: 1,
    d: " M-11,1.125 C-11,1.125 10.75,1.125 10.75,1.125"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-11,1.125 C-11,1.125 10.75,1.125 10.75,1.125"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.ebb0f9b05be6801c2161b43c60938ee8.svg";
export { ForwardRef as ReactComponent };